import demoDayBannerModules from "./demoDayBanner";
import layout from "./layout";

/**
 * Global React components should be added here
 */
const modules = Object.assign(demoDayBannerModules, layout);

export default modules;
